import { useRef } from "react";
import { useGetTextDocumentUploadStatusQuery, UploadStatusValueDto } from "../../../autogen/bff-api";
import { processingStateFromStatus } from "./uploadStatus";

const POLL_INTERVAL_MS = 3000;

const isTerminal = (status: UploadStatusValueDto): boolean =>
  status === UploadStatusValueDto.Confirmed || status === UploadStatusValueDto.Failed;

export const useUploadStatusPoll = ({
  textDocumentId,
  uploadId,
  skip,
}: {
  textDocumentId: string;
  uploadId: string;
  skip?: boolean;
}): "processing" | "ready" | "failed" | undefined => {
  const hasSeenTerminalRef = useRef(false);

  const { data } = useGetTextDocumentUploadStatusQuery(
    { textDocumentId, uploadId },
    {
      pollingInterval: hasSeenTerminalRef.current ? 0 : POLL_INTERVAL_MS,
      skip,
    },
  );

  if (data && isTerminal(data.status)) hasSeenTerminalRef.current = true;

  if (!data) return undefined;
  return processingStateFromStatus(data.status);
};
